const colors = {
  headColor: "#01917E",
  delayHeadColor: "#D03131",
  statusHeadColor: "#E0F2EF",
  headFontColor: "ffffff",
  address: "#D8D6D6",
};
const styles = {
  tableHeadDelayStop: {
    backgroundColor: colors.delayHeadColor,
  },
  tableHead: {
    backgroundColor: colors.headColor,
  },
  tableHeadHeight: {
    height: "52px",
    "& $tableHeaderCell": {
      paddingTop: "6px",
    },
  },
  pickupMarker: {
    marginTop: 5,
    paddingLeft: 10,
  },
  tableHeaderCell: {
    color: colors.headFontColor,
    borderBottom: 0,
    fontSize: "12px",
  },
  accountNumber: {
    float: "right",
    fontSize: "12px",
    paddingRight: "8px",
  },
  nameContainer: {
    height: "20px",
  },
  maxWidth: {
    minWidth: "232px",
  },
  address: {
    clear: "both",
    fontSize: "10px",
    lineHeight: "20px",
    color: colors.address,
    paddingLeft: "12px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    width: "232px",
    textOverflow: "ellipsis",
    display: "inline-block",
  },
  name: {
    float: "left",
    paddingLeft: "12px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    lineHeight: "17px",
    width: "130px",
    textOverflow: "ellipsis",
  },
};

export default styles;
